import { defineMessages } from "react-intl";

const baseId = "t.components.SecurityQuestion.";

export default defineMessages({
securityQuestionLabelQuestion: {
    id: baseId + "securityQuestionLabelQuestion",
    defaultMessage: "Question",
  },
  securityQuestionLabelAnswer: {
    id: baseId + "securityQuestionLabelAnswer",
    defaultMessage: "Answer", 
  },
  securityQuestionPlaceholderQuestionField: {
    id: baseId + "securityQuestionPlaceholderQuestionField",
    defaultMessage: "Question", 
  },
  securityQuestionPlaceholderAnswerField: {
    id: baseId + "securityQuestionPlaceholderAnswerField",
    defaultMessage: "Answer", 
  },
})